// Cristal base de toda la aplicación.
// Discreto, moderno y consistente con iOS.

export const GLASS_SURFACE =
  `
  bg-white
  dark:bg-zinc-900

  supports-[backdrop-filter]:bg-white/82
  dark:supports-[backdrop-filter]:bg-zinc-900/82

  supports-[backdrop-filter]:backdrop-blur-xl
  supports-[backdrop-filter]:backdrop-saturate-150

  border
  border-gray-200/70
  dark:border-white/10

  shadow-sm
`;

// Tarjetas.
// Algo más opacas para mejorar la legibilidad.

export const GLASS_CARD =
  `
  bg-white
  dark:bg-zinc-900

  supports-[backdrop-filter]:bg-white/90
  dark:supports-[backdrop-filter]:bg-zinc-900/90

  supports-[backdrop-filter]:backdrop-blur-lg
  supports-[backdrop-filter]:backdrop-saturate-150

  border
  border-gray-200/70
  dark:border-white/10

  shadow-md
  hover:shadow-lg

  transition-all
  duration-200
`;